export const AboutTheAuthor = {
	title: 'About Kate Pullinger',
	paragraphs: [
		`[Kate Pullinger](https://en.wikipedia.org/wiki/Kate_Pullinger) writes fiction; her most recent books include the novel for smartphones, *Jellybone* (Oolipo), *Landing Gear* (Doubleday) and *The Mistress of Nothing*, which won Canada’s Governor General’s Award. Other projects include the digital war memorial *Letter to an Unknown Soldier* and the digital fiction for children, *Inanimate Alice*. She lives in London and Bath where she is Director of the Centre for Cultural and Creative Industries at Bath Spa University.`,
	]
};

export const AboutTheBook = {
  title: 'About Breathe',
  paragraphs: [
    `*Breathe* is a ghost story. It is a ghost story about a young woman, Flo, who likes to talk to ghosts. Or maybe it’s the ghosts who like to talk to her.`,
    `Full of psychological suspense and haunting interruptions, *Breathe* is a story for anyone who wants to know what it’s like to read a personalised book and feel a chill when they see their digital world and their real world combine.`,
    `Intimate and uncanny, *Breathe* will leave you checking over your shoulder and looking at your phone and your room in a way you never have before.`
  ]
};

export const AboutEAP = {
  title: 'About Editions At Play',
  paragraphs: [
    `Editions At Play is an initiative by [Visual Editions](http://www.visual-editions.com) and Google’s Creative Lab. We champion books powered by the magic of the internet and create a space for new, experimental, digital stories, specifically curated for mobile devices.`,
    `[![EAP Logo](${require('../../backend/static/eap/img/eap-logo-animated-1.gif')} "Click to goto Editions At Play")](https://editionsatplay.withgoogle.com)`,
    `[Read more](https://editionsatplay.withgoogle.com "Click to goto Editions At Play")`,
  ]
};

export const BookCredits = {
  title: 'Book Credits',
  paragraphs: [
    `Ambient Literature project in collaboration with Editions At Play and Google's Creative Lab, Sydney.`,
    `Written by &copy; Kate Pullinger, 2018`,
    `Work copyright &copy; Bath Spa University, 2018`,
    `Published by Editions At Play, with Visual Editions, 2018`,
    `Supported by the Arts and Humanities Research Council`,
    `Made with the help of Google’s Creative Lab`,
    `Weather API data sourcing by [Wunderground](https://www.wunderground.com/weather/api)`,
    `![Wunderground logo](${require('../img/wunderground-logo.png')} "Wunderground logo")`
  ]
};

export const DefaultPosition = {

	// @TODO: somewhere in London...
	latitude: 51.496993,
	longitude: -0.141946,
};

export const IntervalTimes = { 
  intervals: {
    geo: {
      dev: 15000,
      prod: 45000,
    },
    pages: {
      dev: 15000,
      prod: 45000
    },
  },
  get: function(name) {
    return process.env.NODE_ENV === 'development'
      ? this.intervals[name].dev
      : this.intervals[name].prod;
  }
};





// WEBPACK FOOTER //
// ./app/frontend/utils-and-data/data.js